<template>
  <div>

  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
    <v-card-title primary-title class="grey lighten-4">

        <v-avatar size="40">
            <v-img v-if="requirements.sat.foto_user" :src="`/${requirements.sat.foto_user}`" class="mb-4"></v-img>
            <v-icon v-else color="primary">person</v-icon>
        </v-avatar>
        <v-spacer></v-spacer>
        <div>
          <H2>Datos del Agremiado</H2>
            <strong>CPC:</strong> {{ requirements.sat.cpc }} <br>
            <strong>Nombre:</strong> {{ requirements.sat.name_user }}<br>
            <strong>Correo:</strong> {{ requirements.sat.email_user }}<br>
            <strong>Móvil:</strong> {{ requirements.sat.movil_user }}
        </div>

        <v-spacer></v-spacer>
        <div>
          <H2>Datos de la Actuación</H2>
            <strong>TIPO:</strong> {{ requirements.sat.categoria }}<br>
            <strong>RIF:</strong> {{ requirements.sat.number_id }}<br>
            <strong>CLIENTE:</strong> {{ requirements.sat.client }}<br>
            <strong>MONTO:</strong> {{ Number(requirements.sat.amount).toLocaleString('es-VE') }}
        </div>
    </v-card-title>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="elevation-0">
           <v-flex xs12>
              <div class="text-xs-center mt-5">
                <h1> <strong>Nro. Seguridad: {{ requirements.sat ? requirements.sat.security : '' }}</strong> </h1>
                <p>La actuación profesional <strong>{{ requirements.sat ? requirements.sat.categoria : '' }}</strong> que está  sometiendo a consideración para revisión de la SAT,   es con el objeto de: <strong>{{ requirements.sat.question ? requirements.sat.question.descripcion : '' }}</strong></p>
              </div>
            </v-flex>

          <v-container fluid grid-list-md>
            <v-layout row wrap>
               <v-flex xs12>
                <div v-if="showPdf" class="text-xs-center">
                  <v-pagination v-model="page" :length="numPages" :total-visible="5"></v-pagination>
                </div>
              </v-flex>
              <v-flex xs12 md7>
                <v-card class="elevation-0">
                  <v-card-text>
                    <v-progress-linear v-if="loadedRatio > 0 && loadedRatio < 1" :value="Math.floor(loadedRatio * 100)"></v-progress-linear>
                    <pdf v-if="showPdf" :src="`/storage/documents/rap/${document_pdf}`" style="border: 1px; border-style: solid; border-color: #9c1a1a; display: inline-block; width: 100%" :page="page" :rotate="rotate" @progress="loadedRatio = $event" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12 md5>
                <v-card class="elevation-0">
                  <v-card-text>
                    <v-list pa-0 ma-0 subheader three-line v-for="doc in requirements.documents_requirement" :key="doc.id">
                      <v-list-tile pa-0 ma-0 v-for="(document1, index) in doc" :key="document1.id" style="height: 40px">
                        <v-list-tile-action>
                          <v-container fluid>
                            
                            <v-radio-group :rules="[v => !!v || `El ${document1.description} es requerido`]" v-if="document1.required" v-model="form.row[index]" row required>
                              <v-radio color="primary" label="SI" value="true"></v-radio>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <v-radio color="primary" label="NO" value="false"></v-radio>
                            </v-radio-group>

                          </v-container>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <p class="caption">{{ document1.description }} <a v-if="document1.required && document_pdf != document1.src" @click="mostrarPdf(document1.src)">{{ document1.src == null ? '' : 'ver documento' }}</a> </p>
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <p class="caption"><a v-if="document1.required" @click="dialogOpciones(document1)">opciones</a> </p>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

      <v-divider></v-divider>
      <v-flex xs12 v-if="existe_devolucion || form.devolution_activate">
        <v-card class="mx-auto elevation-0" max-width="600">
          <v-card-title></v-card-title>
            <v-card-text>
              <v-list pa-0 ma-0 subheader three-line>
                <v-list-tile pa-0 ma-0 v-for="dev in dev_filter" :key="dev.id" style="height: 40px">

                  <v-list-tile-action>
                    <v-container fluid>
                      <v-checkbox color="primary" v-model="form.devolutions[dev.id]"></v-checkbox>
                    </v-container>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <p class="caption">{{ dev.description }}</p>
                  </v-list-tile-content>

                  <v-list-tile-content>
                    <v-text-field
                          v-if="form.devolutions[dev.id]"
                          v-model="form.devolutions_description[dev.id]"
                          label="Descripcion"
                          :rules="[v => !!v || 'Descripcion es requerido']"
                          required
                      ></v-text-field>
                  </v-list-tile-content>

                </v-list-tile>
              </v-list>
            </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 v-else>
        <v-card class="mx-auto elevation-3" max-width="400" v-if="init_vacio_visado">
          <v-card-title>PROTECCIÓN PROFESIONAL</v-card-title>
            <v-card-text>
              {{ troquel_example }}
            </v-card-text>
          <v-card-actions></v-card-actions>
        </v-card>
      </v-flex>
    <v-card-actions>
        <v-btn color="primary darken-1" @click="$emit('backevent', false)">Atras</v-btn>
        <v-spacer></v-spacer>
        <!-- <v-btn color="blue darken-1" flat @click="submitForm">Guardar</v-btn> -->
        <v-btn color="primary darken-1" @click="submitForm">{{ form.devolution_activate ? 'Devolver' : 'Aprobar' }}</v-btn>
    </v-card-actions>
    </v-form>
  </v-card>



        <!-- dialog para opciones -->
    <v-dialog
      v-model="dialogOptions"
      width="600"
      persistent
    >
      <v-flex xs12 v-if="dialogOptions">
        <v-card>
            <v-card-title>
              Documento: {{ documentoSelected.document_data.description }}
            </v-card-title>
            <v-card-text>
              <p class="caption"><a @click="downloadDocumentsConTroquel()">Descargar Documento con Troquel</a> </p>
              <p class="caption"><a @click="downloadDocuments()">Ver Documento Original</a> </p>
              <!-- descargar documento original
              descargar documento con troquel
              reemplazar documento -->
                <v-layout row wrap class="justify-center">
                    <v-flex>
                            <h2 class="caption">{{ documentoSelected.document_data.description }}</h2>
                            <!-- <v-btn color="blue-grey" class="white--text" @click="deleteItem(documentoSelected.document_data)">
                                Eliminar {{ documentoSelected.document_data.description }}
                                <v-icon right dark>delete</v-icon>
                            </v-btn> -->
                            <DropZone v-on:responseSuccess="responseSuccess($event)" :document="documentoSelected" :ruap_id="documentoSelected.ruap_id"/>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cerrarDialogOptions">Cerrar</v-btn>
              <v-spacer></v-spacer>
              <!-- <v-btn :loading="loading" class="primary" @click="submit">Actualizar</v-btn> -->
            </v-card-actions>
        </v-card>
      </v-flex>
    </v-dialog>
    <!-- fin dialog opciones -->
  </div>
</template>
<script>
import Form from 'vform'
import pdf from 'vue-pdf'
import DropZone from '~/components/DropZone.vue'

export default {

    props: {

      loading: {
        type: Boolean,
        required: true
      },

        requirements: {
            type: Object,
            default: []
        },

        devolutions: {
            type: Array,
            default: []
        }

    },

    components: {
        DropZone,
        pdf
    },

    computed:{
      dev_filter() {
        var devolutions = []
        for (let index = 0; index < this.form.row.length; index++) {
          if(this.form.row[index] === "false") {
            for (const prop in this.requirements.documents_requirement) {
              this.requirements.documents_requirement[prop].forEach((element, indice) => {
                if(indice == index){
                  for (let y = 0; y < element.document_data.devolutions_data.length; y++) {
                    var found = devolutions.find(function(e) { 
                      return e.id == element.document_data.devolutions_data[y].devolutions.id
                    });
                    if(found == undefined){
                      devolutions.push(element.document_data.devolutions_data[y].devolutions)
                    }
                  }
                }
              });
            }
          }
        }

        return devolutions
      },
      init_vacio_visado() {
        for (let index = 0; index < this.form.row.length; index++) {
          if(this.form.row[index] !== "false") {
            return true
          }
        }
        return false
      },
      troquel_example() {
        return `Revise y apruebe todas las opciones para proceder con la Protección del Ejercicio Profesional por el monto de ${Number(this.requirements.sat.amount).toLocaleString('es-VE')}  y el Colegio Certificará que actúa un Contador Público Colegiado bajo el CPC ${this.requirements.sat.cpc} para ejercer la profesión. 1/${this.requirements.sat.pages} páginas.`
      },
      existe_devolucion() {
        for (let index = 0; index < this.form.row.length; index++) {
          if(this.form.row[index] === "false") {
            this.form.devolution_activate = true
            return true
          }
        }

        this.form.devolution_activate = false
        return false
      },
      selected_devolution() {
        for (let index = 0; index < this.form.devolutions.length; index++) {
          if(this.form.devolutions[index]) {
            return this.form.devolutions[index]
          }
        }

        return false
      }
    },

    watch: {
      requirements(v) {
        for (const key in v.documents_requirement) {
          if (v.documents_requirement.hasOwnProperty(key)) {
            for (let index = 0; index < v.documents_requirement[key].length; index++) {
              if(v.documents_requirement[key][index].supervisor_check != null){
                if(v.documents_requirement[key][index].supervisor_check.toString() == "false") {
                  this.form.devolution_activate = true
                }
              }
              let valor = v.documents_requirement[key][index].supervisor_check != null ? v.documents_requirement[key][index].supervisor_check.toString() : v.documents_requirement[key][index].supervisor_check
              // this.form.row[v.documents_requirement[key][index].id] = v.documents_requirement[key][index].supervisor_check != null ? v.documents_requirement[key][index].supervisor_check.toString() : v.documents_requirement[key][index].supervisor_check
              this.form.row[index] = valor
            }
          }
        }

        for (const clave in v.devolution_ruaps) {
          if (v.devolution_ruaps.hasOwnProperty(clave)) {
            this.form.devolutions[v.devolution_ruaps[clave].devolution_id] = !v.devolution_ruaps[clave].resolved
            this.form.devolutions_description[v.devolution_ruaps[clave].devolution_id] = v.devolution_ruaps[clave].observation
          }
        }
      }
    },

    mounted() {
      this.init_module = true
    },

    data: () => ({
        dialogOptions: false,
        documentoSelected: {},
        row: [],
        init_module: false,
        valid: false,
        showPdf: false,
        document_pdf: '',
        loadedRatio: 0,
			  page: 1,
			  numPages: 0,
			  rotate: 0,
        form: new Form({
          devolution_activate: false,
          result: [],
          row: [],
          devolutions: [],
          devolutions_description: [],
          ruap_id: ''
        }),
        active: [],
        avatar: null,
        validDocuments: false,
        open: [],
        users: []
    }),

    methods: {

      async responseSuccess(response){
            let bad = 0
            let esto = this
            response.document_requiremets.forEach(function(element) {
                if(element.document_data.required){
                    if(element.unionize_check == false || element.unionize_check == null){
                        bad++
                    }
                }else{
                    esto.form.id_padre = element.id
                }
            });

            this.validDocuments = bad == 0 ? true : false
        },

      async downloadDocumentsConTroquel() {
        window.open(`/api/cliente/download-documents/1/${this.requirements.sat.id}/${this.documentoSelected.id}/D`);
      },

      async downloadDocuments() {
        window.open(`/storage/documents/rap/${this.documentoSelected.src}`);
      },

      dialogOpciones(document) {
        this.documentoSelected = document
        this.dialogOptions = true
        console.log(document, 'document')
        console.log(this.requirements.sat.id, 'document')
      },

      cerrarDialogOptions() {
        this.dialogOptions = false
        this.documentoSelected = {}
      },

      async mostrarPdf(src) {
        this.document_pdf = src
        this.showPdf = true
      },

      error(err) {
        console.log(err);
      },

      async submitForm() {
        let result = []

        if (this.$refs.form.validate()) {
          if (this.existe_devolucion) {
            if(this.selected_devolution) {
              this.$emit('loading', true)
              this.form.ruap_id = this.requirements.sat.id
              let indice = Object.values(this.requirements.documents_requirement)[0]
              let key = Object.values(this.form.row)
              key.forEach((element, index) => {
                result.push({id: indice[index].id, valor: element})
              });
              this.form.result = result
              await this.$store.dispatch('submitRevisionRuap', this.form)
              this.$emit('backevent', false)
            }else {
              this.$emit('loading', false)
              await this.$store.dispatch('responseMessage', {
                type: 'error',
                text: 'Seleccione los items de devolución correspondientes'
              })
            }
          }else {
            this.$emit('loading', true)
            this.form.ruap_id = this.requirements.sat.id
              let indice = Object.values(this.requirements.documents_requirement)[0]
              let key = Object.values(this.form.row)
              key.forEach((element, index) => {
                result.push({id: indice[index].id, valor: element})
              });
              this.form.result = result
            await this.$store.dispatch('submitRevisionRuap', this.form)
            this.$emit('backevent', false)
          }
        }else {
          await this.$store.dispatch('responseMessage', {
            type: 'error',
            text: 'Revise todas las opciones'
          })
        }
        this.$emit('loading', false)
      }

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/ruap/RuapValidate.vue